<template>
	<div class="row">
		<div class="col-md-6 col-md-offset-3">
			<!-- error message -->
			<div class="alert alert-danger" v-if="errorMessage">
				<strong>{{ errorMessage }}</strong>
			</div>

			<!-- success message -->
			<div class="alert alert-success" v-if="successMessage">
				<strong>{{ successMessage }}</strong>
			</div>

			<div class="panel panel-custom">
				<div class="panel-heading">
					<i class="fa fa-lock pull-right" style="margin-top:5px;"></i>
					<strong class="text-uppercase">CONFIRMAR PRESENÇA</strong>
				</div>
				<div class="panel-body">
					<form @submit.prevent="preSave">
						<template v-if="form.idMunicipe && form.idAgendamento && form.hash">
							<v-input
								label="ID DO MUNÍCIPE"
								v-model="form.idMunicipe"
								disabled
							></v-input>

							<v-input
								label="ID DO AGENDAMENTO"
								v-model="form.idAgendamento"
								disabled
							></v-input>

							<v-textarea
								label="HASH"
								v-model="form.hash"
								rows="2"
								disabled
							></v-textarea>

							<template v-if="confirming">
								<form @submit.prevent="save" class="form-horizontal">
									<div class="form-group" style="margin-bottom:0;">
										<div class="col-xs-6">
											<label class="text-uppercase" style="line-height:35px;margin-bottom:0px">Confirma?</label>
										</div>
										<div class="col-xs-6 text-right">
											<button type="button" class="btn btn-danger" @click="confirming = false">NÃO</button>
											<button type="submit" class="btn btn-success">SIM</button>
										</div>
									</div>
								</form>
							</template>

							<template v-else>
								<button type="submit" class="btn btn-success pull-right">CONFIRMAR AGENDAMENTO</button>
							</template>
						</template>

						<template v-else>
							<div class="alert alert-warning" style="margin-bottom:15px;">
								<strong>NÃO HÁ AGENDAMENTO DISPONÍVEL PARA CONFIRMAÇÃO</strong>
							</div>
							<router-link to="/" class="btn btn-success pull-right" exact>RETORNAR PARA A PÁGINA INICIAL</router-link>
						</template>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery';
	import Form from 'helpers/form';
	import rules from 'helpers/validationRules';

	export default {
		data() {
			let idMunicipe = this.$route.query.idMunicipe;
			let idAgendamento = this.$route.query.idAgendamento;
			let hash = this.$route.query.hash;

			return {
				confirming: false,
				validating: false,
				errorMessage: '',
				successMessage: '',

				form: new Form({
					idMunicipe: idMunicipe,
					idAgendamento: idAgendamento,
					hash: hash
				})
			};
		},

		methods: {
			validate(rule, value, arg, message) {
				if (message === undefined) {
					message = arg;
				}

				if (this.validating) {
					return rules[rule](value, arg) ? '' : message;
				}
			},

			hasValidationErrors() {
				let fields = $('.has-error');

				return fields.length > 0;
			},

			preSave() {
				this.validating = true;
				this.errorMessage = '';

				this.$nextTick(() => {
					if (this.hasValidationErrors() === false) {
						this.confirming = true;
					} else {
						let firstErrorField = $('.has-error:first');

						window.scrollTo(0, firstErrorField.position().top);
					}
				});
			},

			save() {
				let url = `${Config.BASE_URL}/agenda/confirmarPresenca`;

				this.validating = false;
				this.confirming = false;

				this.form.save(url)
					.then(() => {
						this.successMessage = 'Agendamento confirmado com sucesso!';
					})
					.catch(error => {
						this.errorMessage = error.responseJSON.message || error.responseJSON.errorMessage;
					})
					.done(() => {
						window.scrollTo(0, 0);

						setTimeout(() => {
							this.errorMessage = '';
							this.successMessage = '';

							this.$router.push('/agendas');
							location.reload();
						}, 10000);
					});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// confirmacaoPresenca.vue?729592a8